import PropTypes from "prop-types"
import React from "react"

const SectionHeading = ({ label }) => {
  return <h5 className="font-semibold">{label}</h5>
}

SectionHeading.propTypes = {
  label: PropTypes.string.isRequired,
}

export default SectionHeading
